import React, { useState, useEffect } from 'react';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import moment from 'moment';
import PerfectScrollbar from 'react-perfect-scrollbar';
import { makeStyles } from '@material-ui/styles';
import {
  Card,
  CardActions,
  CardContent,
//  Avatar,
  Checkbox,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Typography,
  Button,
  TablePagination,
  LinearProgress,
} from '@material-ui/core';

//import { getInitials } from 'helpers';

const useStyles = makeStyles(theme => ({
  root: {},
  row: {
    height: '62px',
    display: 'flex',
    alignItems: 'center',
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  rowIcons: {
    height: '62px',
    display: 'flex',
    alignItems: 'center',
    //paddingLeft: theme.spacing(8),
    '& > *': {
      margin: theme.spacing(1),
    },
  },
  content: {
    padding: 0
  },
  inner: {
    minWidth: 1050
  },
  nameContainer: {
    display: 'flex',
    alignItems: 'center'
  },
  actions: {
    justifyContent: 'flex-end'
  }
}));

const ManageTable = props => {
  const { 
    className, 
    userRole,
    type,
    items,
    onSetSelectedItems,
    onClickOpenRegister,
    onClickOpenEdit,
    onClickOpenDelete,
    disableEditButton,
    disableDeleteButton,

    openProgress,
    page,
    rowsPerPage,
    item_total,
    onPageChange,
    onRowsPerPageChange,

    ...rest 
  } = props;

  const classes = useStyles();

  const [selectedItems, setSelectedItems] = useState([]);
  // const [rowsPerPage, setRowsPerPage] = useState(10);
  // const [page, setPage] = useState(0);

  const handleSelectAll = event => {

    let selectedItems;

    if (event.target.checked) {
      if (type === 'user') {
        selectedItems = [];
        items.map((item) => {
          if (item.userid === 'admin' || item.role === 'admin') {

          }
          else {
            selectedItems = [...selectedItems, item.id];
          }
        });
      }
      else if (type === 'area') {
        selectedItems = items.filter(item => {
          if (item.have_groups) {
            return false;
          }
          return true;
        });
        selectedItems = selectedItems.map(item => item.id);
      }
      else {
        selectedItems = items.map(item => item.id);
      }
    } else {
      selectedItems = [];
    }

    setSelectedItems(selectedItems);
    onSetSelectedItems(selectedItems);
  };

  const handleSelectOne = (event, id) => {
    const selectedIndex = selectedItems.indexOf(id);
    let newSelectedItems = [];

    if (selectedIndex === -1) {
      newSelectedItems = newSelectedItems.concat(selectedItems, id);
    } else if (selectedIndex === 0) {
      newSelectedItems = newSelectedItems.concat(selectedItems.slice(1));
    } else if (selectedIndex === selectedItems.length - 1) {
      newSelectedItems = newSelectedItems.concat(selectedItems.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelectedItems = newSelectedItems.concat(
        selectedItems.slice(0, selectedIndex),
        selectedItems.slice(selectedIndex + 1)
      );
    }

    setSelectedItems(newSelectedItems);
    onSetSelectedItems(newSelectedItems);
  };

  // const handlePageChange = (event, page) => {
  //   setPage(page);
  // };

  // const handleRowsPerPageChange = event => {
  //   setRowsPerPage(event.target.value);
  // };

  const checkDisabledAdmin = (index) => {
    if (index >= items.length){
      return false;
    }
    const item = items[index];
    //console.log(item);
    if (item.userid === 'admin' || item.role === 'admin') {
      return true;
    }
    return false;
  }

  useEffect(() => {
    //console.log('componentDidUpdate & type changed');

  }, [type]);

  useEffect(() => {
    //console.log('componentDidUpdate & items changed');

    const newSelected = selectedItems.filter(id => {
      const findObj = items.find(obj => obj.id === id);
      return findObj !== undefined && findObj !== null;
    });

    setSelectedItems(newSelected);
    onSetSelectedItems(newSelected);

  }, [items]);

  return (
    <div>
      {userRole !== 'user' && (
        <div className={classes.row}>
          {type==='rule' ? 
            null
            : 
            <Button
              color="primary"
              variant="contained"
              onClick={ onClickOpenRegister }
            >
              등록
            </Button>
          }
          
          <Button
            color="primary"
            variant="contained"
            disabled={ disableEditButton }
            onClick={ onClickOpenEdit }
          >
            수정
          </Button>

          {type !== 'rule' &&
            <Button
            style={{
              //  borderRadius: 35,
                backgroundColor: disableDeleteButton ? "#DCDBDC" : "#E00000",
                color: disableDeleteButton ? "#A6A6A6":"#FFFFFF"
                // padding: "18px 36px",
                // fontSize: "18px"
              }}
              variant="contained"
              disabled={ disableDeleteButton }
              onClick={ onClickOpenDelete }
            >
              삭제
            </Button>
          }
         
        </div>
      )}
      
      <Card
        {...rest}
        className={clsx(classes.root, className)}
      >
        <CardContent className={classes.content}>
        {type === 'user' && (
          <PerfectScrollbar>
            {openProgress && <LinearProgress /> }
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={items.length > 0 && selectedItems.length === items.length}
                      color="primary"
                      indeterminate={
                        selectedItems.length > 0 &&
                        selectedItems.length < items.length
                      }
                      onChange={handleSelectAll}
                    />
                  </TableCell>
                  <TableCell>번호</TableCell>
                  <TableCell>사용자아이디</TableCell>
                  <TableCell>사용자명</TableCell>
                  <TableCell>이메일</TableCell>
                  <TableCell>등록일</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {items.slice(0, rowsPerPage).map((item, index) => (
                  <TableRow
                    className={classes.tableRow}
                    hover
                    key={item.id}
                    selected={selectedItems.indexOf(item.id) !== -1}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={selectedItems.indexOf(item.id) !== -1}
                        color="primary"
                        disabled={checkDisabledAdmin(index)}
                        onChange={event => handleSelectOne(event, item.id)}
                        value="true"
                      />
                    </TableCell>
                    <TableCell>{index}</TableCell>
                    <TableCell>
                      <div className={classes.nameContainer}>
                        <Typography variant="body1">{item.userid}</Typography>
                      </div>
                    </TableCell>
                    <TableCell>
                      <div className={classes.nameContainer}>
                        <Typography variant="body1">{item.name}</Typography>
                      </div>
                    </TableCell>
                    <TableCell>{item.email}</TableCell>
                    <TableCell>{moment(item.reg_at).format('YYYY-MM-DD')}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          
          </PerfectScrollbar>
        )}

        {type === 'area' && (
          <PerfectScrollbar>
            {openProgress && <LinearProgress /> }
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={items.length > 0 && selectedItems.length === items.length}
                      color="primary"
                      indeterminate={
                        selectedItems.length > 0 &&
                        selectedItems.length < items.length
                      }
                      onChange={handleSelectAll}
                    />
                  </TableCell>
                  <TableCell>번호</TableCell>
                  <TableCell>권역명</TableCell>
                  <TableCell>등록자</TableCell>
                  <TableCell>등록일</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {items.slice(0, rowsPerPage).map((item, index) => (
                    <TableRow
                      className={classes.tableRow}
                      hover
                      key={item.id}
                      selected={selectedItems.indexOf(item.id) !== -1}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={selectedItems.indexOf(item.id) !== -1}
                          color="primary"
                          onChange={event => handleSelectOne(event, item.id)}
                          value="true"
                          disabled={item.have_groups}
                        />
                      </TableCell>
                      <TableCell>{index}</TableCell>
                      <TableCell>
                        <div className={classes.nameContainer}>
                          <Typography variant="body1">{item.name}</Typography>
                        </div>
                      </TableCell>
                      <TableCell>{item.reg_user}</TableCell>
                      <TableCell>{moment(item.reg_at).format('YYYY-MM-DD')}</TableCell>
                    </TableRow>
                ))}
              </TableBody>
            </Table>
          
          </PerfectScrollbar>
        )}

        {type === 'group' && 
          (
            <PerfectScrollbar>
              {openProgress && <LinearProgress /> }
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={items.length > 0 && selectedItems.length === items.length}
                        color="primary"
                        indeterminate={
                          selectedItems.length > 0 &&
                          selectedItems.length < items.length
                        }
                        onChange={handleSelectAll}
                      />
                    </TableCell>
                    <TableCell>번호</TableCell>
                    <TableCell>권역명</TableCell>
                    <TableCell>그룹명</TableCell>
                    <TableCell>등록자</TableCell>
                    <TableCell>등록일</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {items.slice(0, rowsPerPage).map((item, index) => (
                    <TableRow
                      className={classes.tableRow}
                      hover
                      key={item.id}
                      selected={selectedItems.indexOf(item.id) !== -1}
                    >
                      <TableCell padding="checkbox">
                        <Checkbox
                          checked={selectedItems.indexOf(item.id) !== -1}
                          color="primary"
                          onChange={event => handleSelectOne(event, item.id)}
                          value="true"
                        />
                      </TableCell>
                      <TableCell>{index}</TableCell>
                      <TableCell>
                        <div className={classes.nameContainer}>
                          <Typography variant="body1">{item.area}</Typography>
                        </div>
                      </TableCell>
                      <TableCell>
                        <div className={classes.nameContainer}>
                          <Typography variant="body1">{item.name}</Typography>
                        </div>
                      </TableCell>
                      <TableCell>{item.reg_user}</TableCell>
                      <TableCell>{moment(item.reg_at).format('YYYY-MM-DD')}</TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            
            </PerfectScrollbar>
          ) 
        }

        {type === 'rule' && (
          <PerfectScrollbar>
            {openProgress && <LinearProgress /> }
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell padding="checkbox">
                    <Checkbox
                      checked={items.length > 0 && selectedItems.length === items.length}
                      color="primary"
                      indeterminate={
                        selectedItems.length > 0 &&
                        selectedItems.length < items.length
                      }
                      onChange={handleSelectAll}
                    />
                  </TableCell>
                  <TableCell>광고유효시간(%)</TableCell>
                  <TableCell>수정자</TableCell>
                  <TableCell>수정일</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {items.slice(0, rowsPerPage).map((item, index) => (
                  <TableRow
                    className={classes.tableRow}
                    hover
                    key={item.id}
                    selected={selectedItems.indexOf(item.id) !== -1}
                  >
                    <TableCell padding="checkbox">
                      <Checkbox
                        checked={selectedItems.indexOf(item.id) !== -1}
                        color="primary"
                        onChange={event => handleSelectOne(event, item.id)}
                        value="true"
                      />
                    </TableCell>
                    <TableCell>
                      <div className={classes.nameContainer}>
                        <Typography variant="body1">{item.play_rule}%</Typography>
                      </div>
                    </TableCell>
                    <TableCell>{item.modified_user}</TableCell>
                    <TableCell>{moment(item.modified_at).format('YYYY-MM-DD')}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </PerfectScrollbar>
        )}

        </CardContent>
        <CardActions className={classes.actions}>
          <TablePagination
            labelRowsPerPage=''
            component="div"
            count={item_total}
            onChangePage={onPageChange}
            onChangeRowsPerPage={onRowsPerPageChange}
            page={page}
            rowsPerPage={rowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </CardActions>
      </Card>

    </div>
  );
};

ManageTable.propTypes = {
  className: PropTypes.string,
  type: PropTypes.string,
  items: PropTypes.array.isRequired,
  onSetSelectedItems: PropTypes.func,
};

ManageTable.defaultProps = {
  items: [],
};

export default ManageTable;
